"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var baseComponent_1 = require("./base/baseComponent");
// @ts-ignore
var ko = require("knockout");
var $ = require("jquery");
var _ = require("lodash");
var ajaxUtils_1 = require("../../app/utils/ajaxUtils");
var dateTimeUtils_1 = require("../utils/dateTimeUtils");
var windowUtils_1 = require("../../app/utils/windowUtils");
var CommentFormComponent = (function (_super) {
    __extends(CommentFormComponent, _super);
    function CommentFormComponent(params, element, templateNodes) {
        var _this = this;
        _super.call(this, params, element, templateNodes);
        this.$comments = $(".comments");
        this.$element = $(this.element);
        this.commentData = ko.observable();
        this._isTextChange = false;
        this.errorMessages = ko.observableArray([]);
        this.text = ko.observable("");
        this.mode = ko.observable();
        this.isIgnored = ko.observable();
        this.isPinned = ko.observable();
        this.canBePinned = ko.pureComputed(function () {
            var commentData = _this.commentData();
            return !commentData && _this.canPinned;
        });
        this.initialized = ko.observable(false);
        this.froalaOptions = {
            imageUploadURL: window["app"].rootUrl + "file/froalaUploadImage?standardAvailability=true",
            heightMin: 75,
            heightMax: 400,
            charCounterMax: 25000,
            placeholderText: "Написать комментарий...",
            pastePlain: true,
            charCounterCount: false,
            toolbarBottom: true,
            toolbarSticky: false,
            imageDefaultDisplay: "block",
            imageEditButtons: ["imageReplace", "imageAlign", "imageDisplay",
                "imageAlt", "imageSize", "imageRemove"],
            imageDefaultAlign: "left",
            imageDefaultWidth: 0,
            htmlAllowedTags: [
                "a", "b", "blockquote", "br", "del", "div", "em", "embed", "i",
                "iframe", "img", "p", "small", "span", "strike", "strong", "u"
            ],
            toolbarButtons: [
                "bold", "italic", "underline", "strikeThrough", "|",
                "spoiler", "quote", "emoticons", "insertLink", "insertImage", "insertVideo", "|", "undo", "redo"
            ],
            toolbarButtonsMD: [
                "bold", "italic", "underline", "strikeThrough", "|",
                "spoiler", "quote", "emoticons", "insertLink", "insertImage", "insertVideo", "|", "undo", "redo"
            ],
            toolbarButtonsSM: [
                "bold", "italic", "underline", "strikeThrough", "|",
                "spoiler", "quote", "emoticons", "insertLink", "insertImage", "insertVideo", "|", "undo", "redo"
            ],
            toolbarButtonsXS: [
                "bold", "quote", "emoticons", "spoiler", "insertLink", "insertImage", "insertVideo", "|", "undo", "redo"
            ]
        };
        this.disableSubmit = ko.pureComputed(function () {
            var text = _this.text();
            var isEmpty = _.isEmpty(text);
            if (!isEmpty && !_this._isTextChange) {
                _this.setDirtyText(true);
            }
            else if (isEmpty && _this._isTextChange) {
                _this.setDirtyText(false);
            }
            return isEmpty;
        });
        this.rootId = params.rootId;
        this.rootType = params.rootType;
        this.canPinned = params.canPinned;
        this.onSubmit = this.defaultOnSubmit;
        this.initData();
        this.$element.find("textarea").on("froalaEditor.initialized", function (e, editor) {
            _this.initialized(true);
        });
    }
    CommentFormComponent.prototype.setDirtyText = function (value) {
        if (value === void 0) { value = true; }
        windowUtils_1.default.setDirty(value);
        this._isTextChange = value;
        if (this.app.canBeHandledByApp()) {
            try {
                this.app.getAppMobileHandler().setIsDirty(value);
            }
            catch (ex) {
                console.error(ex);
            }
        }
    };
    CommentFormComponent.prototype.startEditing = function (comment, onSubmit, onCancel, onDelete) {
        this.commentData(comment);
        this.onSubmit = onSubmit;
        this.onCancel = onCancel;
        this.onDelete = onDelete;
        this.resetState();
        this.mode("edit");
        this.isIgnored(comment.isIgnored);
        this.isPinned(comment.isPinned);
        $(".edit-reply textarea").froalaEditor("events.focus");
    };
    CommentFormComponent.prototype.startCreating = function (comment, onSubmit) {
        this.commentData(comment);
        this.onSubmit = onSubmit;
        this.resetState();
        this.mode("new");
        this.isIgnored(comment.isIgnored);
        this.isPinned(comment.isPinned);
    };
    CommentFormComponent.prototype.resetState = function () {
        var text = this.commentData() ? this.commentData().text : "";
        this.text(text);
        this.errorMessages([]);
    };
    CommentFormComponent.prototype.submit = function () {
        var _this = this;
        if (this.processing())
            return;
        this.processing(true);
        this.errorMessages([]);
        var text = this.text();
        var data = _.assign(this.commentData() || {}, {
            rootId: this.rootId,
            rootType: this.rootType,
            text: text,
            isPinned: this.isPinned()
        });
        if (this.mode() == "new") {
            data.isPinned = $('#isPinned').is(':checked');
        }
        ajaxUtils_1.AjaxUtils.post("comment/submit", data)
            .done(function (result) {
            if (result.isSuccessful) {
                alert("Комментарий успешно отправлен.");
                if (result.data.isPinned) {
                    window.location.reload();
                    return;
                }
                _this.onSubmit(result.data);
                _this.onSubmit = _this.defaultOnSubmit;
                _this.initData();
            }
            else {
                _this.errorMessages(result.messages);
            }
        }).always(function () {
            _this.processing(false);
        });
    };
    CommentFormComponent.prototype.cancel = function () {
        this.initData();
        this.onSubmit = this.defaultOnSubmit;
        if (this.onCancel) {
            this.onCancel();
        }
    };
    CommentFormComponent.prototype.defaultOnSubmit = function (data) {
        var $html = $(data.html);
        this.$comments.prepend($html);
        if (this.$comments.hasClass("empty")) {
            this.$comments.removeClass("empty");
        }
        dateTimeUtils_1.default.displayTime($html);
    };
    CommentFormComponent.prototype.remove = function () {
        var _this = this;
        if (this.processing())
            return;
        this.processing(true);
        this.errorMessages([]);
        ajaxUtils_1.AjaxUtils.post("comment/delete", { id: this.commentData().id })
            .done(function (result) {
            if (result.isSuccessful) {
                _this.onDelete(result.data);
                _this.initData();
            }
            else {
                _this.errorMessages(result.messages);
            }
        }).always(function () {
            _this.processing(false);
        });
    };
    CommentFormComponent.prototype.initData = function () {
        this.commentData(null);
        this.resetState();
        this.mode("new");
        this.isIgnored(false);
        this.isPinned(false);
    };
    Object.defineProperty(CommentFormComponent.prototype, "isTextChange", {
        get: function () {
            return this._isTextChange;
        },
        enumerable: true,
        configurable: true
    });
    return CommentFormComponent;
}(baseComponent_1.default));
ko.components.register("mobile-comment-form", {});
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = CommentFormComponent;
//# sourceMappingURL=mobileCommentForm.js.map